import { useEffect, useState } from 'react'
import "../splash/splash.css"
import splashlogo from '../splash/images/logo.png'
import w from '../assets/alphabet/W.svg'
import o from '../assets/alphabet/O.svg'
import r from '../assets/alphabet/R.svg'
import d from '../assets/alphabet/D.svg'
import { useNavigate } from 'react-router-dom';
import goldimg from '../assets/gold.svg'
import silverimg from '../assets/silver.svg'
import bronze from '../assets/bronze.svg'
import axios from 'axios'

// Define the style with a high z-index
const accountLinkStyle = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    color: '#fff',
    textDecoration: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    zIndex: 99999
};

const Splash = () => {

    const [listModal, setListModal] = useState(false);
    const [tournamentModal, setTournamentModal] = useState(false);
    const [creditpoint, setCreditpoint] = useState(0);
    const [freepoint, setFreepoint] = useState(0);

    useEffect(() => {
        setTimeout(() => setListModal(true), 1500);
    }, [])

    const navigate = useNavigate();
    const handlePaid = (apiType) => {
        localStorage.setItem("strickData", []);
        localStorage.removeItem("gametype");
        if (apiType === "paid") {
            localStorage.setItem("apitype", "paid");
        }
        else {
            localStorage.setItem("apitype", "free");
        }

        //Strange -- we navigate, then change the local storage,
        //which triggers the useEffect in LetterText.jsx
        //which then calls the all important getData() function
        navigate('/letter-text', { replace: true });

        //PRINT LOCAL STORAGE
        console.log("============================================");
        console.log("LOCAL STORAGE AFTER HANDLE PAID");
        console.log("============================================");
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i); // Get the key at index `i`
            const value = localStorage.getItem(key); // Retrieve the value using the key
            console.log(`${key}: ${value}`);
        }
    }

    const userId = localStorage.getItem('UserId');
    const gettoken = localStorage.getItem('token');

    const handleOpen = async () => {
        localStorage.setItem("strickData", []);
        setListModal(false);
        setTournamentModal(true);

        await axios.get(`${process.env.VITE_APP_API_URL}/lockitapi/Word/GetUserPointDetail?${userId}`, {
            headers: {
                Authorization: `Bearer ${gettoken}`
            }
        }).then((response) => {

            console.log("LOGIN -- HANDLE SUBMIT");
            console.log("============================================");
            console.log("Token = ", gettoken, " Sets localStorage.setItem('token')");
            console.log("User Id = ", userId, " Sets localStorage.setItem('UserId')");
            console.log('Response: ', response)



            setCreditpoint(response.data.data[0].creditPoint)
            setFreepoint(response.data.data[0].freeGame)
        })

    }
    const handlecredit = (type) => {
        localStorage.setItem("strickData", []);
        localStorage.removeItem("apitype");
        navigate('/letter-text', { replace: true });
        //debugger
        if (type === "creditfree") {
            localStorage.setItem("gametype", "creditfree");
        }
        else {
            localStorage.setItem("gametype", "creditpaid");
        }
    }


    const backProgress = () => {
        setListModal(true);
        setTournamentModal(false);
    }

    return (
        <>
            <a 
                href={process.env.REACT_APP_COMPUSULT_OFFICE_URL}
                style={accountLinkStyle}
                target="_blank"
                rel="noopener noreferrer"
            >
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                >
                    <path d="M15 18l-6-6 6-6"/>
                </svg>
                Account
            </a>

            <div className='splash-bg'>
                <div className='splash-content'>
                    <img src={w} alt='W' className='wordone' />
                    <img src={o} alt='O' className='wordtwo' />
                    <div className='splash-logo'>
                        <img src={splashlogo} alt='splashlogo' />
                        {/* <div className='play-btn'>
                            <Link to="/letter-text">Play Now</Link>
                        </div> */}
                    </div>
                    <img src={r} alt='R' className='wordthree' />
                    <img src={d} alt='D' className='wordfour' />
                </div>
            </div>


            {listModal && (
                <div className='tournamentList'>
                    <div className="modal show">
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <div className="modal-body">
                                <div className="listmodal">
                                    <div className="modallist-cont">
                                        <div className='tournament-prize'>
                                            <h2>Tournament Prize</h2>
                                            <div className='win-flex'>
                                                <div className='win-silver silver'>
                                                    <img src={silverimg} alt='silverimg' />
                                                    <p><b>Prize:</b> $150</p>
                                                </div>
                                                <div className='win-silver gold'>
                                                    <img src={goldimg} alt='goldimg' />
                                                    <p><b>Prize:</b> $300</p>
                                                </div>
                                                <div className='win-silver bronze'>
                                                    <img src={bronze} alt='bronze' />
                                                    <p><b>Prize:</b> $50</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer free-game-btn">
                                            <button onClick={() => handleOpen()}>Join Tournament in progress</button>
                                            <button onClick={() => handlePaid("free")}>Practice</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tournamentModal && (
                <div className='tournamentList progress_modal'>
                    <div className="modal show">
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <div className="modal-body">
                                <div className="listmodal">
                                    <div className="modallist-cont">
                                        <div className='tournament-prize'>
                                            <h2>Tournament Prize</h2>
                                            <div className='win-flex'>
                                                <div className='win-silver silver'>
                                                    <img src={silverimg} alt='silverimg' />
                                                    <p><b>Prize:</b> $150</p>
                                                </div>
                                                <div className='win-silver gold'>
                                                    <img src={goldimg} alt='goldimg' />
                                                    <p><b>Prize:</b> $300</p>
                                                </div>
                                                <div className='win-silver bronze'>
                                                    <img src={bronze} alt='bronze' />
                                                    <p><b>Prize:</b> $50</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer free-game-btn">
                                            <div className='creditpoint'>
                                                <h4>Credit Point: <span>{creditpoint}</span></h4>
                                                <h4>Free Game: <span>{freepoint}</span></h4>
                                            </div>
                                            <div className='creditbutton'>
                                                <button onClick={() => handlecredit("creditpaid")}>Use your Credit Point</button>
                                                <button onClick={() => handlecredit("creditfree")}>Use your Free Game</button>
                                            </div>
                                            <div className='creditback'>
                                                <button onClick={() => backProgress()}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevron-left" width="19" height="19" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M15 6l-6 6l6 6" />
                                                </svg>Back</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            )}

        </>
    )
}



export default Splash